import { render } from "./doneHeader.vue?vue&type=template&id=4d268fe5"
import script from "./doneHeader.vue?vue&type=script&lang=js"
export * from "./doneHeader.vue?vue&type=script&lang=js"

import "./doneHeader.vue?vue&type=style&index=0&id=4d268fe5&lang=css"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__